import React from 'react';
import S from './SiteWide.styles';
const SiteWide = ({ children, className, width = 'default' }) => {
    return (React.createElement(S.Container, { className: className, width: width }, children));
};
export default SiteWide;
